import { useQuery } from '@tanstack/react-query';
import {
    DEVICES_PERMISSIONS_QUERY_KEY,
    DEVICES_PERMISSIONS_STALE_TIME,
    getDevicesPermissions
} from '../components/CreateDeviceContent/CreateDeviceContent.queries';

export const useDevicesPermissions = ({ enabled = true } = {}) => {
    const { data, isLoading, error } = useQuery({
        queryKey: DEVICES_PERMISSIONS_QUERY_KEY,
        queryFn: getDevicesPermissions,
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: DEVICES_PERMISSIONS_STALE_TIME,
        enabled
    });

    return {
        permissions: data?.permissions,
        locations: data?.locations,
        cnpjs: data?.cnpjs,
        company: data?.company,
        totalEmployees: data?.totalEmployees,
        isLoadingPermissions: isLoading,
        permissionsError: error
    };
};
